import { createContext, ReactNode, useContext } from 'react';
import { useStore } from 'zustand';
import type { StoreApi } from 'zustand/vanilla';

const AppStoreContext = createContext<StoreApi<unknown> | null>(null);

interface AppStoreProviderProps {
  store: StoreApi<unknown>;
  children: ReactNode;
}

export function AppStoreProvider({ store, children }: AppStoreProviderProps) {
  return (
    <AppStoreContext.Provider value={store}>
      {children}
    </AppStoreContext.Provider>
  );
}

export type StoreSelector<TState, TSelected> = (state: TState) => TSelected;

export function useAppStoreSelector<TState, TSelected>(
  selector: StoreSelector<TState, TSelected>
) {
  const store = useContext(AppStoreContext);

  if (!store) {
    throw new Error('App store context is not available');
  }

  return useStore(store as StoreApi<TState>, selector);
}
